import * as C from '../constants/merchantTypes';
import * as filterEventTypes from '../constants/filterTypes';

/**
 * merchant filter reducer responsible for stateful filters
 * @param  {object} state  initial state
 * @param  {object} action redux action object
 * @return {object}        redux store state
 */

const initialState = { appliedFilters: {}, filterEvents: { showFilterForm: false } };

function filter(state = initialState, action) {
  switch (action.type) {
    case C.SET_MERCHANTLIST_FILTER:
      return { ...state, ...action.payload };
    case C.SET_APPLIED_FILTER:
      return { ...state, appliedFilters: action.payload };
    case filterEventTypes.FILTER_DROPDOWN_EVENT:
      return { ...state, filterEvents: action.payload };
    default:
      return state;
  }
}


export default filter;
